import React, { useEffect, useState } from "react";
import { store } from "../../store";
import { apiLabs, apiLabsV2 } from "../../Services/api";
import history from "../../Services/history";
import Denied from "../../Components/Denied";
import Dashboard from "../../Components/Dashboard";
import { Container, Grid, Typography } from "@material-ui/core";
import useStyle from "./style";
import AddFile from "./AddFile";
import { DetailsSeal } from "./DetailsSeal";

export const FIXED_BACKGROUND_FLAG = "#FF710A";
export const FIXED_FONT_COLOR_FLAG = "#FFF";

const AddSeal = (props) => {
  const {
    location: { idPage },
  } = props;

  const [auth, setAuth] = useState(null);
  const [fullscreen] = useState(false);

  const [seal, setSeal] = useState({
    title: "",
    description: "",
    date_start: "",
    date_end: "",
    time_start: "",
    time_end: "",
    type: "",
    color: FIXED_FONT_COLOR_FLAG,
    background: FIXED_BACKGROUND_FLAG,
    status: "",
    file: "",
    csv: "",
  });

  const style = useStyle();

  useEffect(() => {
    async function verifyAuth() {
      const { profile } = store.getState().user;
      const res = await apiLabs.post("valid_key", {
        id: profile.id,
        menu_id: idPage,
      });
      if (res.data.message === "User not authorized") {
        return setAuth("denied");
      }
      if (res.data.message === "User authorized") {
        return setAuth("authorized");
      }
      return history.push({ pathname: "/", state: { from: props.location } });
    }

    verifyAuth();
  }, [idPage, props.location]);

  const isVisible = seal.csv || seal.image;

  return (
    <Dashboard title="Adicionar Selos" fullscreen={fullscreen}>
      {auth === "denied" && <Denied />}
      {auth === "authorized" && (
        <>
          <Container>
            <Grid container className={style.wrapperSeals}>
              <Grid spacing={2} className={style.wrapperTitle}>
                <Typography variant="h1">Adicionar Selos</Typography>
                <Typography variant="span">
                  Adicione abaixo a imagem do selo e a planilha com os produtos
                  que deverão exibi-lo no site.
                </Typography>
              </Grid>

              <AddFile seal={seal} setSeal={setSeal} />

              {isVisible && <DetailsSeal seal={seal} setSeal={setSeal} />}
            </Grid>
          </Container>
        </>
      )}
    </Dashboard>
  );
};

export default AddSeal;
